<template>
	<div v-if="touserinfo" class="thisimpagebox">
		<div class="header">
			<div @click="closeimpage" class="imback"><i class="el-icon-back"></i></div>
			<span @click="close" class="close">
				<i class="el-icon-close"></i>
			</span>
		</div>
		<div class="imheader">
			<div class="userinfo">
				<div v-if="touserinfo.thumb" class="userface" style="background-size: 100% 100%;" :style="{'background-image':'url('+(apiurl+touserinfo.thumb)+')'}"></div>
				<div v-else class="userface" style="background-size: 100% 100%;" :style="{'background-image':'url('+apiurl+'/public/img/thumb.jpg'}"></div>
				<div class="username">{{touserinfo.username}}</div>
			</div>
		</div>
		<div @click="closesendbox" class="immessagebox">
			<div v-for="item in imlist">
				<div v-if="item.from_id == sendim_to_id" class="hemessagebox">
					<div class="hemessage">
						<div class="content" v-html="item.content" @click="bigimg($event)"></div>
						<div class="addtime">{{item.addtime}}</div>
					</div>
				</div>
				<div v-if="item.from_id == user_id" class="mymessagebox">
					<div class="mymessage">
						<div class="content" v-html="item.content" @click="bigimg($event)"></div>
						<div class="addtime">{{item.addtime}}</div>
					</div>
				</div>
			</div>
			<div class="imemptybox"></div>
		</div>
		<div class="footerbox">
			<div v-if="openemojibox" class="emojibigbox">
				<div class="emojibox">
					<span @click="copyemoji(emoji.text)" v-for="(emoji,index) in emojis">{{emoji.text}}</span>
				</div>
			</div>
			<div v-if="openfilebox" class="filebigbox">
				<div class="filebox">
					<div class="fileboxheader">
						<div @click="changefiletab(0)" class="filetab" :class="{'active':filetab==0}">圖像</div>
						<div @click="changefiletab(1)" class="filetab" :class="{'active':filetab==1}">PDF</div>
						<div @click="changefiletab(2)" class="filetab" :class="{'active':filetab==2}">文件</div>
					</div>
					<div class="filecontent">
						<div v-if="filetab == 0" class="fileuploadbox">
							<div class="fileboxbon">
								<el-button type="primary" @click="$refs.imagefile.click()">上傳圖像</el-button>
								<input @change="imagefile" class="uploadfileinput" type="file" ref="imagefile" accept="image/jpeg,image/png" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="opensendbox" class="sendimbigbox">
				<div class="sendimbox">
					<div  ref="sendbox" class="sendimcontent" contenteditable="true" v-html="imcontent" @blur="imcontent=$event.target.innerText"></div>
					<div class="sendimbonbox">
						<el-button @click="sendim" type="primary">發送</el-button>
					</div>
				</div>
			</div>
			<div class="sendbox">
				<div @click.stop="clickopenemojibox" class="faceico">
					<svg class="icon svg-icon" aria-hidden="true">
						<use xlink:href="#icon-face"></use>
					</svg>
				</div>
				<div @click.stop="clickopenfilebox" class="imageico">
					<i class="el-icon-paperclip"></i>
				</div>
				<div @click.stop="clickopensendbox" class="sendtextbox">
					<div class="sendtext"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['sendim_to_id', 'refim'],
		data() {
			return {
				touserinfo: {},
				opensendbox: false,
				openemojibox: false,
				openfilebox:false,
				imcontent: '',
				emojis: {},
				imlist: {},
				user_id: 0,
				filetab: 0,
				imgbase64:''

			}
		},
		watch: {
			refim() {

				this.getimlist();
			}
		},
		methods: {
			bigimg(event){
				let imgdata = event.target.src;
				if(imgdata){
					this.$emit('showbigimg', imgdata);
				}
				
			},
			imagefile(e) {
				let that = this;
				let inpudom = this.$refs.imagefile;
				let file = inpudom.files[0];
				let imgtype = file.type;
				
				let fileReader = new FileReader();
				fileReader.readAsDataURL(file);
				fileReader.onload = function(event) {
					let result = event.target.result;
					let image = new Image();
					image.src = result;
					image.onload = function() {
						let cvs = document.createElement('canvas');
						let scale = 1;
						if (this.width > 1000||this.height>1000) {
							if (this.width > this.height) {
								scale = 1000 / this.width;
							} else {
								scale = 1000 / this.height;
							}
						}
						cvs.width = this.width * scale;
						cvs.height = this.height * scale;
						let ctx = cvs.getContext('2d');
						ctx.drawImage(this, 0, 0, cvs.width, cvs.height);
						let imgbase64 = cvs.toDataURL(imgtype,1);
						that.imcontent = that.imcontent + '<img  class="im_thumb" style="width:250px" src="'+imgbase64+'">';
						
						that.openfilebox = false;
						that.opensendbox = true;
					}
				}

			},
			changefiletab(tab) {
				switch (tab) {
					case 0:
						this.filetab = 0;
						break;
					case 1:
						this.filetab = 1;
						break;
					case 2:
						this.filetab = 2;
						break;
				}
			},
			copyemoji(thisemoji) {
				
				this.imcontent = this.imcontent + thisemoji;
				
				this.openemojibox = false;
				this.opensendbox = true;
			},
			closeimpage() {
				this.$emit('closeimpage', false);
			},
			close() {
				this.$emit('closemsgcenter', false);
			},
			clickopenfilebox(){
				this.openfilebox = true;
				this.openemojibox = false;
			},
			clickopenemojibox() {
				this.openemojibox = true;
				this.openfilebox = false;
			},
			clickopensendbox() {
				this.opensendbox = true;
			},
			closesendbox() {
				this.opensendbox = false;
				this.imcontent = '';
				this.openemojibox = false;
				this.openfilebox = false;
			},
			getemoji() {
				this.post('/api/im/emoji', {}).then((res) => {

					this.emojis = res;
				})
			},
			gettouserinfo() {
				let user_id = this.sendim_to_id;
				this.post('/api/im/touserinfo', {
					user_id: user_id
				}).then((res) => {
					this.touserinfo = res;

				})
			},
			getimlist() {
				let from_id = parseInt(this.sessionRead('user_id'));
				let to_id = this.sendim_to_id;
				this.post('/api/im/imlist', {
					from_id: from_id,
					to_id: to_id,
				}).then((res) => {
					this.imlist = res;

				}).then(() => {
					this.viewed();
					this.scrollToBottom();
				})
			},
			viewed() {
				let to_id = parseInt(this.sessionRead('user_id'));
				this.post('/api/im/viewed', {
					from_id: this.sendim_to_id,
					to_id: to_id,
				}).then((res) => {

				})
			},
			sendim() {
				if (!this.imcontent) {
					this.$notify({
						title: '通知',
						type: 'error',
						message: '请输入发送内容！',

					});
				} else {
					let from_id = parseInt(this.sessionRead('user_id'));
					let to_id = this.sendim_to_id;
					let content = this.imcontent;
					this.post('/api/im/newimsave', {
						from_id: from_id,
						to_id: to_id,
						content: content
					}).then((res) => {
						if (res == 'success') {
							let username = this.sessionRead('username');
							let thumb = this.sessionRead('thumb');
							let swoolecontent = {
							    'type': 'im',
								username: username,
								thumb: thumb,
								'content': content
							};

							this.wssend(from_id, to_id, swoolecontent);
							this.getimlist();
							this.closesendbox();
						}

					})
				}
			},
			wssend(from_id, to_id, content) {
				let swoolecontent = JSON.stringify(content);
				let databasename = localStorage.getItem('databasename');
					
				let data = {
					databasename:databasename,
					from_id: from_id,
					to_id: to_id,
					content: swoolecontent
				}
				websocket.send(JSON.stringify(data));
			},
			scrollToBottom: function() {
				this.$nextTick(() => {
					var container = this.$el.querySelector(".immessagebox");
					container.scrollTop = container.scrollHeight;
				})
			}

		},
		created() {
			this.gettouserinfo();
			this.user_id = parseInt(this.sessionRead('user_id'));

			this.getimlist();
			this.getemoji();

		}
	}
</script>

<style scoped>
	.uploadfileinput {
		display: none;
	}

	.fileboxbon {
		position: relative;
	}

	.filecontent {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 80px;
	}

	.filetab.active {
		border-bottom: 1px solid #e2e2e2;
		color: #3399ff;
	}

	.filetab {
		flex: 1 1 33.3%;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 25px;
	}

	.fileboxheader {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
	}

	.imemptybox {
		height: 80px;
	}

	.sendimcontent {
		margin-bottom: 10px;
		word-wrap: break-word;
		word-break: break-all;
		min-height: 40px;

	}

	.sendimbonbox {
		display: flex;
		justify-content: flex-end;
	}

	.sendimbon {
		padding: 4px 10px;
	}

	.sendimbox {
		background: #fff;
		border-radius: 10px;
		border: 1px solid #e2e2e2;
		padding: 10px;
	}

	.emojibox {
		border-radius: 10px;
		font-size: 18px;

		border: 1px solid #e2e2e2;
		padding: 10px;

		background: #fff;
		min-height: 100px;
	}

	.emojibox span {
		line-height: 25px;
	}

	.emojibigbox {
		position: absolute;
		width: 280px;
		left: 5px;
		bottom: 50px;

		z-index: 2;
	}

	.filebigbox {
		position: absolute;
		width: 280px;
		left: 5px;
		bottom: 50px;

		z-index: 2;
	}

	.filebox {
		border-radius: 4px;
		font-size: 18px;

		border: 1px solid #e2e2e2;


		background: #fff;
		min-height: 100px;
	}

	.sendimbigbox {
		position: absolute;
		width: 280px;
		left: 5px;
		bottom: 50px;

		z-index: 1;

	}

	.sendtext {
		flex: 0 210px;
		height: 35px;
		background: #fff;
		border-radius: 10px;
	}

	.sendtextbox {
		flex: 1 1 auto;
		display: flex;
		justify-content: center;
	}

	.imageico {
		font-size: 25px;
		color: #616161;
		flex: 0;
		margin-right: 10px;
	}

	.faceico {
		font-size: 25px;
		color: #616161;
		margin-right: 10px;
		flex: 0;
	}

	.footerbox {
		padding: 4px 0;
		height: 48px;
		display: flex;
		position: relative;
		z-index: 1;

	}

	.sendbox {
		background: #f2f2f2;
		flex: 1 1 100%;
		display: flex;
		padding: 0 10px;
		align-items: center;
	}

	.immessagebox {
		height: calc(100vh - 155px);
		overflow-x: hidden;


	}

	.mymessage {
		background: #e7f6e7;
		padding: 10px;
		border-radius: 10px;
		flex: 0 85%;
		position: relative;
		padding-bottom: 40px;
	}

	.mymessagebox {
		display: flex;
		padding: 10px;
		justify-content: flex-end;
	}

	.addtime {
		position: absolute;
		right: 10px;
		bottom: 10px;
		font-size: 12px;
		color: #999;
	}

	.hemessage {
		background: #f2f2f2;
		padding: 10px;
		border-radius: 10px;
		flex: 0 85%;
		position: relative;
		padding-bottom: 40px;
	}

	.hemessagebox {
		display: flex;
		padding: 10px;
	}

	.imheader {
		padding: 0 15px;
		border-bottom: 1px solid #e2e2e2;

	}

	.username {
		font-size: 18px;
		font-weight: bold;
	}

	.userface {
		width: 45px;
		height: 45px;
		border-radius: 50%;
		margin-right: 15px;
	}

	.userinfo {
		display: flex;
		align-items: center;
	}

	.imback {
		font-size: 28px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #3399ff;
	}

	.close {
		border-radius: 50%;
		font-size: 18px;
		width: 25px;
		height: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #3399ff;
		color: #fff;
	}

	.header {
		padding: 15px;
		padding-bottom: 5px;
		display: flex;
		justify-content: space-between;
		position: relative;
	}

	.thisimpagebox {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #fff;
		z-index: 999;
		overflow: hidden;
	}
</style>
